import * as React from "react";
const SvgFiRrTaxAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tax-alt_svg__a)">
      <path
        fill="#062147"
        d="M14 1.5a1.5 1.5 0 1 1 3.001.001A1.5 1.5 0 0 1 14 1.5M22.5 5a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 22.5 5m.5 7.5v8c0 1.995-2.58 3.5-6 3.5-2.151 0-3.968-.596-5.022-1.534C10.761 23.476 8.625 24 6.5 24 3.27 24 0 22.798 0 20.5v-16C0 2.202 3.27 1 6.5 1S13 2.202 13 4.5v5.353C14.047 9.319 15.433 9 17 9c3.42 0 6 1.505 6 3.5m-2 2.647c-1.047.534-2.433.853-4 .853s-2.953-.319-4-.853V16.5c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5zM11 7.091C9.774 7.692 8.133 8 6.5 8S3.226 7.692 2 7.091V8.5C2 8.936 3.577 10 6.5 10S11 8.936 11 8.5zm-9 4V12.5c0 .436 1.577 1.5 4.5 1.5s4.5-1.064 4.5-1.5v-1.409c-1.226.601-2.867.909-4.5.909s-3.274-.308-4.5-.909M2 16.5c0 .436 1.577 1.5 4.5 1.5s4.5-1.064 4.5-1.5v-1.409c-1.226.601-2.867.909-4.5.909s-3.274-.308-4.5-.909zm11-4c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5-1.519-1.5-4-1.5-4 .971-4 1.5m-11-8C2 4.936 3.577 6 6.5 6S11 4.936 11 4.5 9.423 3 6.5 3 2 4.064 2 4.5m9 16v-1.409c-1.226.601-2.867.909-4.5.909s-3.274-.308-4.5-.909V20.5c0 .436 1.577 1.5 4.5 1.5s4.5-1.064 4.5-1.5m10 0v-1.353c-1.047.534-2.433.853-4 .853s-2.953-.319-4-.853V20.5c0 .529 1.519 1.5 4 1.5s4-.971 4-1.5M16.445 7.832a1 1 0 0 0 1.387-.277l4-6a1.001 1.001 0 0 0-1.664-1.11l-4 6a1 1 0 0 0 .277 1.387"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tax-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTaxAlt;
